export default class ScheduleListRow {
	static mergeSchedule(list, schedule) {
		let merged;
		list.some(o => {
			if (o.merge(schedule)) {
				merged = o;
				return true;
			}
			return false;
		});
		if (!merged) {
			list.push(schedule);
			return false;
		}
		/* remerge */
		for (let i = list.length - 1; i >= 0; i--) {
			let s = list[i];
			if (merged === s)
				continue;
			if (merged.merge(s)) {
				list.splice(i, 1);	
			}
		}
	
		return true;
	}
	
	static anotherMergeSchedule(list, schedule) {
		let merged;
		list.some(o => {
			if (o.anotherMerge(schedule)) {
				merged = o;
				return true;
			}
			return false;
		});
		if (!merged) {
			list.push(schedule);
			return false;
		}
		/* remerge */
		for (let i = list.length - 1; i >= 0; i--) {
			let s = list[i];
			if (merged === s)
				continue;
			if (merged.anotherMerge(s)) {
				list.splice(i, 1);	
			}
		}
	
		return true;
	}

	static createMergedSchedule(schedules) {
		let merged = new Array();
		schedules.forEach(s => {
			ScheduleListRow.mergeSchedule(merged, s.clone());
		});
		return merged;
	}

	static mergeOverSchedule(list, master, slave) {
		const array_remove = (array, item, equation) => {
			if (equation === undefined)
				equation = (a, b) => { return a === b };
			let ret = null;
			array.some((v, i) => {
				if (equation(v, item)) {
					array.splice(i, 1);
					ret = item;
				}
			});
			return ret;
		};
		const subtract = (target) => {
			let tmp = new Array();
			target.forEach(t => {
				master.forEach(m => {
					t.createSubtract(m).forEach(r => {
						let master_others = master.filter(v => { return v !== m; });
						let remains = [r];
						master_others.forEach(m => {
							remains.concat().forEach(r => {
								array_remove(remains, r);
								r.createSubtract(m).forEach(r => {
									ScheduleListRow.mergeSchedule(remains, r.clone());
								});
							});
						});
						remains.forEach(r => {
							ScheduleListRow.mergeSchedule(tmp, r.clone());
						});
					});
				});
			});
			return tmp;
		};
		let remains = subtract(slave);
		let alerts = new Array();
		remains.forEach(r => {
			let tmp = new Array();
			let prev = master.filter(m => {
				return m.begin.code <= r.begin.code;
			}).sort((a, b) => {
				return b.code - a.code;
			})[0];
			let next = master.filter(m => {
				return r.end.code <= m.end.code;
			}).sort((a, b) => {
				return a.code - b.code;
			})[0];
			if (prev)
				tmp.push(prev);
			if (next)
				tmp.push(next);
			tmp.forEach(m => {
				let overs = m.createOvers(r);
				overs.forEach(o => {
					ScheduleListRow.mergeSchedule(alerts, o.clone());
				});
			});
		});
		subtract(alerts).forEach(a => {
			list.push(a);
		});
	}

	static get ITEM_TYPE() {
		const ITEM_TYPE = {
			UNKNOWN: 0,
			PROJECT: 1,
			MEMBER: 2,
		};
		return ITEM_TYPE;
	}
	static get STATUS() {
		const STATUS = {
			UNKNOWN: 0,
			PROGRESS: 1,
			DONE: 2,
		};
		return STATUS;
	}

	get isProject() { return this.item_type === ScheduleListRow.ITEM_TYPE.PROJECT }
	get isMember() { return this.item_type === ScheduleListRow.ITEM_TYPE.MEMBER }
	get isProgress() { return this.status === ScheduleListRow.STATUS.PROGRESS }
	get isDone() { return this.status === ScheduleListRow.STATUS.DONE }
	get hasChildren() { return this.children.length > 0 }
	get codeWithType() { return this.item_type + '-' + this.code }

	constructor(params) {
		if (params.item_type !== undefined)
			this.item_type = params.item_type;
		else
			this.item_type = ScheduleListRow.ITEM_TYPE.UNKNOWN;

		this.code = params.code;
		this.seq = params.seq;
		this.name = params.name;

		if (params.classes !== undefined)
			this.classes = params.classes;
		else
			this.classes = new Array();

		if (params.status !== undefined)
			this.status = params.status;
		else
			this.status = ScheduleListRow.STATUS.UNKNOWN;

		if (params.schedules !== undefined)
			this.schedules = params.schedules;
		else
			this.schedules = new Array();

		if (params.children !== undefined)
			this.children = params.children;
		else
			this.children = new Array();

		if(params.is_updated !== undefined) {
			this.is_updated = params.is_updated;
		} else {
			this.is_updated = true
		}
		
		if(params.alert !== undefined)
			this.alert = params.alert;
		else
			this.alert = false;
		
		if(params.remarks !== undefined)
			this.remarks = params.remarks;
		else
			this.remarks = '';
		
		this.color_code = params.color_code;
	}

	setStatusDone() {
		this.status = ScheduleListRow.STATUS.DONE;
	}

	setStatusProgress() {
		this.status = ScheduleListRow.STATUS.PROGRESS;
	}

	static createOverlapSchedules(hystack, needle) {
		let overlaps = new Array();
		needle.forEach(a => {
			hystack.forEach(b => {
				if (a === b)
					return;
				let overlap = a.createOverlap(b);
				if (overlap) {
					ScheduleListRow.mergeSchedule(overlaps, overlap);
				}
			});
		});

		return overlaps;
	}

	createOverlapSchedules(needle) {
		return ScheduleListRow.createOverlapSchedules(this.schedules.concat(), needle);
	}

	createOverChildrenSchedules() {
		let ret = new Array();
		let merged_parent = ScheduleListRow.createMergedSchedule(this.schedules);
		let merged_children = new Array();
		this.children.forEach(m => {
			let merged_child = ScheduleListRow.createMergedSchedule(m.schedules);
			merged_child.forEach(child => {
				ScheduleListRow.mergeSchedule(merged_children, child);
			});
		});
		ScheduleListRow.mergeOverSchedule(ret, merged_parent, merged_children);

		return ret;
	}
}
